const breadCrumb = "Lançamento de Notas/Conceitos/Faltas por Aluno";

const routes = [
  {
    path: "/lancamento-notas-conceitos-faltas-aluno",
    name: "lancamento-notas-conceitos-faltas-aluno",
    meta: {
      breadCrumb: breadCrumb,
      requireAuth: false,
    },
    component: () =>
      import(
        "@/views/PermitirLancamentoNotasFaltasAluno/LancamentoNotasFaltasHome.vue"
      ),
  },
  {
    path: "/lancamento-notas-conceitos-faltas-aluno/disciplinas",
    name: "lancamento-notas-conceitos-faltas-aluno-disciplinas",
    meta: {
      breadCrumb: breadCrumb,
      requireAuth: false,
    },
    component: () =>
      import(
        "@/views/PermitirLancamentoNotasFaltasAluno/LancamentoNotasConceitosFaltasAluno.vue"
      ),
  },
];

export default routes;
